import { get } from '../utils/index'

export const getDashboardProgressReport = async (data) => {
  // const page = data?.queryKey[1] || 1
  const startDate = new Date(data?.queryKey?.[1]?.startDate)
  const endDate = new Date(data?.queryKey?.[1]?.endDate)
  const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/dashboard/progress-report', payload).then((res) => res.data)
}
export const getDashboardRecentActivity = async (data) => {
  // const page = data?.queryKey[1] || 1
  const startDate = new Date(data?.queryKey?.[1]?.startDate)
  const endDate = new Date(data?.queryKey?.[1]?.endDate)
  const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/dashboard/recent-activity', payload).then((res) => res.data)
}
export const getDashboardJobcardStatus = async (data) => {
  const page = data?.queryKey[2] || 1
  const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[3]?.startDate)
  const endDate = new Date(data?.queryKey?.[3]?.endDate)
  const departmentId = data?.queryKey?.[4]
  const payload = { page, limit: 10, status: data?.queryKey[1], startDate, endDate, departmentId }
  return get(`/dashboard/jobcard-status?jobCardStatus=${status}`, payload).then((res) => res.data)
}
export const getDashboardTaskStatus = async (data) => {
  const page = data?.queryKey[2] || 1
  const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[3]?.startDate)
  const endDate = new Date(data?.queryKey?.[3]?.endDate)
  const departmentId = data?.queryKey?.[4]
  const payload = { page, limit: 10, status: data?.queryKey[1], startDate, endDate, departmentId }
  return get(`/dashboard/task-status?jobCardStatus=${status}`, payload).then((res) => res.data)
}
export const getDashboardJobcardTaskStatus = async (data) => {
  const page = data?.queryKey[2] || 1
  const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[3]?.startDate)
  const endDate = new Date(data?.queryKey?.[3]?.endDate)
  const payload = { page, limit: 10, status: data?.queryKey[1], startDate, endDate }
  return get(`/dashboard/jobcard-and-task-status?jobCardStatus=${status}`, payload).then((res) => res.data)
}

// -----------------------ADMIN DASHBOARD --------------------------------//
export const getAdminDashboardRecentActivity = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/recent-activity').then((res) => res.data)
}
// Task overview list
export const getAdminTaskOverview = async (data) => {
  // // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/task-overview').then((res) => res.data)
}
// Machine list
export const getAdminMachine = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/machines').then((res) => res.data)
}
// BreakDown list
export const getAdminBreakDown = async (data) => {
  // const page = data?.queryKey[1] || 1
  const startDate = new Date(data?.queryKey?.[1]?.startDate)
  const endDate = new Date(data?.queryKey?.[1]?.endDate)
  const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/break-down-list', payload).then((res) => res.data)
}
// machine pie chart and bar chart list
export const getAdminMachineTime = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/machine-time').then((res) => res.data)
}
// machine pie chart single
export const getSingleMachine = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  const resource = data?.queryKey?.[1]
  const payload = { resource }
  return get('/admin-dashboard/machine-time', payload).then((res) => res.data)
}
// bar chart single
export const getSingleDepartment = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  const departmentId = data?.queryKey?.[1]
  const payload = { departmentId }
  return get('/admin-dashboard/machine-time', payload).then((res) => res.data)
}
// four box starting of dashboard
export const getAdminAllCount = async (data) => {
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  // const payload = { status: data?.queryKey[1], startDate, endDate }
  return get('/admin-dashboard/all-counts').then((res) => res.data)
}

// -----------------------Manager DASHBOARD --------------------------------//
// Task overview
export const getManagerOverview = async (data) => {
  const departmentId = data?.queryKey?.[1]
  // const page = data?.queryKey[1] || 1
  // const startDate = new Date(data?.queryKey?.[1]?.startDate)
  // const endDate = new Date(data?.queryKey?.[1]?.endDate)
  const payload = { departmentId }
  return get('/dashboard/task-overview', payload).then((res) => res.data)
}
// Ongoing Tasks
export const getManagerApproveTasks = async (data) => {
  const page = data?.queryKey[1] || 1
  // const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[2]?.startDate)
  const endDate = new Date(data?.queryKey?.[2]?.endDate)
  const department = data?.queryKey?.[3]
  const payload = { page, limit: 10, startDate, endDate, department }
  return get('/dashboard/list?jobCardStatus=approved', payload).then((res) => res.data)
}
export const getManagerScheduledTasks = async (data) => {
  const page = data?.queryKey[1] || 1
  // const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[2]?.startDate)
  const endDate = new Date(data?.queryKey?.[2]?.endDate)
  const department = data?.queryKey?.[3]
  const payload = { page, limit: 10, startDate, endDate, department }
  return get('/dashboard/list?jobCardStatus=scheduled', payload).then((res) => res.data)
}
export const getManagerOngoingTasks = async (data) => {
  const page = data?.queryKey[1] || 1
  // const status = data?.queryKey[1]
  const startDate = new Date(data?.queryKey?.[2]?.startDate)
  const endDate = new Date(data?.queryKey?.[2]?.endDate)
  const department = data?.queryKey?.[3]
  const payload = { page, limit: 10, startDate, endDate, department }
  return get('/dashboard/ongoing-task', payload).then((res) => res.data)
}

export const dashboardApi = {
  getDashboardProgressReport,
  getDashboardTaskStatus,
  getDashboardRecentActivity,
  getDashboardJobcardTaskStatus,
  getDashboardJobcardStatus,
  getAdminDashboardRecentActivity,
  getAdminTaskOverview,
  getAdminBreakDown,
  getAdminAllCount,
  getAdminMachineTime,
  getSingleMachine,
  getSingleDepartment,
  getAdminMachine,
  getManagerOverview,
  getManagerApproveTasks,
  getManagerScheduledTasks,
  getManagerOngoingTasks
}
